import { reactive, toRefs } from 'vue'
const state = reactive({
  visible: false,
  message: null,
  type: 'IOS'
})

function showLoader ({ message, type = 'IOS' }) {
  state.visible = true
  state.message = message
  state.type = type
}

function hideLoader () {
  state.visible = false
}

export function useLoader () {
  return {
    showLoader,
    hideLoader,
    ...toRefs(state)
  }
}
